var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2710_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 200C0 310.457 89.5431 400 200 400C310.457 400 400 310.457 400 200C400 89.543 310.457 0 200 0C89.5431 0 0 89.543 0 200Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 25L191.816 48.6491L203.64 52.4911L199.5 25Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 25L207.184 48.6491L195.36 52.4911L199.5 25Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.148 42.1821H198.282V54.6152L223.148 42.1821Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.148 42.1821L203.031 56.7981L195.723 46.7395L223.148 42.1821Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 69.9834L206.432 46.3343L194.607 50.1763L214.116 69.9834Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 69.9834L193.999 55.3674L201.307 45.3089L214.116 69.9834Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.852 42.1821H200.718V54.6152L175.852 42.1821Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.852 42.1821L195.969 56.7981L203.277 46.7395L175.852 42.1821Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.884 69.9834L192.568 46.3343L204.393 50.1763L184.884 69.9834Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.884 69.9834L205.001 55.3674L197.693 45.3089L184.884 69.9834Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 323.394L191.816 347.043L203.64 350.885L199.5 323.394Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 323.394L207.184 347.043L195.36 350.885L199.5 323.394Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.148 340.576H198.282V353.009L223.148 340.576Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.148 340.576L203.031 355.192L195.723 345.133L223.148 340.576Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 368.377L206.432 344.728L194.607 348.57L214.116 368.377Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 368.377L193.999 353.761L201.307 343.702L214.116 368.377Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.852 340.576H200.718V353.009L175.852 340.576Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.852 340.576L195.969 355.192L203.277 345.133L175.852 340.576Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.884 368.377L192.568 344.728L204.393 348.57L184.884 368.377Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.884 368.377L205.001 353.761L197.693 343.703L184.884 368.377Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3032 174.197L42.6192 197.846L54.4437 201.688L50.3032 174.197Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3032 174.197L57.9873 197.846L46.1627 201.688L50.3032 174.197Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9512 191.379H49.085V203.812L73.9512 191.379Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9512 191.379L53.834 205.995L46.5261 195.936L73.9512 191.379Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.918 219.18L57.2339 195.531L45.4093 199.373L64.918 219.18Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.918 219.18L44.8008 204.564L52.1088 194.506L64.918 219.18Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6543 191.379H51.5204V203.812L26.6543 191.379Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6543 191.379L46.7714 205.995L54.0794 195.936L26.6543 191.379Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6875 219.18L43.3716 195.531L55.1961 199.373L35.6875 219.18Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6875 219.18L55.8046 204.564L48.4967 194.506L35.6875 219.18Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.285 89.9717L130.402 75.3557L123.094 65.2972L110.285 89.9717Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.285 89.9717L117.969 66.3226L129.794 70.1646L110.285 89.9717Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.251 62.1702L121.369 76.7861L128.677 66.7276L101.251 62.1702Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.251 62.1702H126.118V74.6032L101.251 62.1702Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.901 44.988L117.217 68.6372L129.042 72.4792L124.901 44.988Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.901 44.988L132.585 68.6372L120.761 72.4792L124.901 44.988Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.518 89.9717L119.4 75.3557L126.708 65.2972L139.518 89.9717Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.518 89.9717L131.834 66.3226L120.009 70.1646L139.518 89.9717Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.551 62.1704L128.434 76.7864L121.126 66.7278L148.551 62.1704Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.551 62.1704H123.685V74.6035L148.551 62.1704Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9067 144.582L77.2227 120.932L65.3981 124.774L84.9067 144.582Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9067 144.582L64.7896 129.966L72.0976 119.907L84.9067 144.582Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6753 144.582L75.7924 129.966L68.4845 119.907L55.6753 144.582Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6753 144.582L63.3594 120.932L75.1839 124.774L55.6753 144.582Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6421 116.78L66.7592 131.396L74.0672 121.338L46.6421 116.78Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6421 116.78H71.5082V129.213L46.6421 116.78Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9409 116.781L73.8238 131.397L66.5158 121.338L93.9409 116.781Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9409 116.781H69.0748V129.214L93.9409 116.781Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2915 99.5986L77.9756 123.248L66.151 127.09L70.2915 99.5986Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2915 99.5986L62.6074 123.248L74.432 127.09L70.2915 99.5986Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9399 265.978H69.0738V278.411L93.9399 265.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9399 265.978L73.8228 280.594L66.5148 270.535L93.9399 265.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9067 293.779L77.2227 270.13L65.3981 273.972L84.9067 293.779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9067 293.779L64.7896 279.163L72.0976 269.105L84.9067 293.779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6753 293.779L75.7924 279.163L68.4845 269.105L55.6753 293.779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6753 293.779L63.3594 270.13L75.1839 273.972L55.6753 293.779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.291 248.795L77.9751 272.445L66.1505 276.287L70.291 248.795Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.291 248.795L62.607 272.445L74.4315 276.287L70.291 248.795Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6421 265.978H71.5082V278.411L46.6421 265.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6421 265.978L66.7592 280.593L74.0672 270.535L46.6421 265.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.55 320.587H123.684V333.02L148.55 320.587Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.55 320.587L128.433 335.203L121.125 325.144L148.55 320.587Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.517 348.388L131.833 324.739L120.008 328.581L139.517 348.388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.517 348.388L119.4 333.772L126.708 323.714L139.517 348.388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.285 348.388L130.402 333.772L123.094 323.714L110.285 348.388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.285 348.388L117.969 324.739L129.794 328.581L110.285 348.388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.901 303.405L132.585 327.054L120.761 330.896L124.901 303.405Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.901 303.405L117.217 327.054L129.042 330.896L124.901 303.405Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.252 320.587H126.119V333.02L101.252 320.587Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.252 320.587L121.37 335.203L128.678 325.144L101.252 320.587Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.697 174.197L356.381 197.846L344.557 201.688L348.697 174.197Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.697 174.197L341.013 197.846L352.838 201.688L348.697 174.197Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.049 191.379H349.915V203.812L325.049 191.379Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.049 191.379L345.166 205.995L352.474 195.937L325.049 191.379Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.082 219.181L341.766 195.532L353.59 199.374L334.082 219.181Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.082 219.181L354.199 204.565L346.891 194.506L334.082 219.181Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.346 191.379H347.48V203.812L372.346 191.379Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.346 191.379L352.229 205.995L344.921 195.937L372.346 191.379Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.313 219.181L355.629 195.532L343.805 199.374L363.313 219.181Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.313 219.181L343.196 204.565L350.504 194.506L363.313 219.181Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.715 89.9717L268.598 75.3557L275.906 65.2972L288.715 89.9717Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.715 89.9717L281.031 66.3226L269.206 70.1646L288.715 89.9717Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.748 62.1702L277.631 76.7861L270.323 66.7276L297.748 62.1702Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.748 62.1702H272.882V74.6032L297.748 62.1702Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.099 44.9883L281.783 68.6374L269.958 72.4794L274.099 44.9883Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.099 44.9883L266.415 68.6374L278.239 72.4794L274.099 44.9883Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.482 89.9717L279.6 75.3557L272.292 65.2972L259.482 89.9717Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.482 89.9717L267.166 66.3226L278.991 70.1646L259.482 89.9717Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.449 62.1704L270.566 76.7864L277.874 66.7278L250.449 62.1704Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.449 62.1704H275.315V74.6035L250.449 62.1704Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.093 144.582L321.777 120.933L333.601 124.775L314.093 144.582Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.093 144.582L334.21 129.966L326.902 119.908L314.093 144.582Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.325 144.582L323.208 129.966L330.516 119.908L343.325 144.582Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.325 144.582L335.641 120.933L323.816 124.775L343.325 144.582Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.358 116.781L332.241 131.397L324.933 121.338L352.358 116.781Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.358 116.781H327.492V129.214L352.358 116.781Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.059 116.781L325.176 131.397L332.484 121.339L305.059 116.781Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.059 116.781H329.925V129.214L305.059 116.781Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.708 99.5991L321.024 123.248L332.849 127.09L328.708 99.5991Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.708 99.5991L336.392 123.248L324.568 127.09L328.708 99.5991Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.06 265.978H329.926V278.411L305.06 265.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.06 265.978L325.177 280.594L332.485 270.535L305.06 265.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.093 293.779L321.777 270.13L333.601 273.972L314.093 293.779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.093 293.779L334.21 279.163L326.902 269.105L314.093 293.779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.325 293.779L323.208 279.163L330.516 269.104L343.325 293.779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.325 293.779L335.641 270.13L323.816 273.972L343.325 293.779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.708 248.795L321.024 272.445L332.849 276.287L328.708 248.795Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.708 248.795L336.393 272.445L324.568 276.287L328.708 248.795Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.357 265.978H327.491V278.411L352.357 265.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.357 265.978L332.24 280.594L324.932 270.535L352.357 265.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 320.587H275.316V333.02L250.45 320.587Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 320.587L270.567 335.203L277.875 325.144L250.45 320.587Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.483 348.388L267.167 324.739L278.992 328.581L259.483 348.388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.483 348.388L279.6 333.772L272.292 323.714L259.483 348.388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.715 348.388L268.598 333.772L275.906 323.714L288.715 348.388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.715 348.388L281.031 324.739L269.206 328.581L288.715 348.388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.099 303.405L266.415 327.054L278.239 330.896L274.099 303.405Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.099 303.405L281.783 327.054L269.958 330.896L274.099 303.405Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.748 320.586H272.881V333.019L297.748 320.586Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.748 320.586L277.63 335.202L270.322 325.144L297.748 320.586Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2710_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.e876d37e03c5fa2f8dd67f86b7ec90c2.svg";
export { ForwardRef as ReactComponent };